export default class PeakDisplay {
    constructor(parent, showGraticules = false, peakHold = true) {
        this.canvas = document.createElement('canvas');
        this.canvas.style.display = 'block';
        this.canvas.style.height = "100%";
        this.canvas.style.width = "100%";
        parent.appendChild(this.canvas);

        this.width = 0;
        this.height = 0;

        this.graticules = showGraticules;
        this.heightOffset = this.graticules ? 15 : 0;
        this.dbFallRate = 2;
        this.windowSizeMs = 100;

        this.hasPeakHold = peakHold;
        this.peakCount = 0;
        this.lastPeakValue = -144;
        this.lastPeakPos = 0;

        this.lastValue = -144;
        this.lastLine = 0;

        this._checkResize();
        this.paint();
    }

    destroy() {
        this.canvas.parentNode.removeChild(this.canvas);
        this.canvas = null;
        this.gradient = null;
        this.ctx = null;
    }

    update(peaks, windowSizeMs = 100) {
        this.windowSizeMs = windowSizeMs;

        let value = peaks.db || -144;
        if (value < this.lastValue) {
            this.lastValue -= this.dbFallRate;
        }
        else {
            this.lastValue = value;
        }

        this.paint();

        if (this.hasPeakHold) {
            if (value > this.lastPeakValue) {
                this.lastPeakValue = value;
                this.peakCount = 0;
            }
            else {
                this.peakCount++;
            }

            if (this.peakCount === (1000 / windowSizeMs) * 3) {     // hold peak for 3 seconds
                this.lastPeakValue = -144;
                this.peakCount = 0;
            }

            this._drawPeakHold();
        }
    }

    paint() {
        let ctx = this.ctx;

        this.line = this._calculateLength(this.lastValue);

        if (this.line <= this.lastLine) {
            ctx.clearRect(this.line, this.heightOffset, this.lastLine - this.line, this.height - this.heightOffset);
        }

        if (this.line >= this.lastLine) {
            ctx.fillStyle = this.gradient;
            ctx.fillRect(this.lastLine, this.heightOffset, this.line - this.lastLine, this.height - this.heightOffset);
        }

        this.lastLine = this.line;
    }

    _drawPeakHold() {
        let ctx = this.ctx;

        let peakPos = this._calculateLength(this.lastPeakValue);

        if ((this.lastPeakPos != peakPos) && (this.lastPeakPos > this.line)) {
            ctx.clearRect(this.lastPeakPos - 1, this.heightOffset, 2, this.height - this.heightOffset);
        }

        if (peakPos > this.line) {
            ctx.strokeStyle = 'red';
            ctx.beginPath();
            ctx.moveTo(peakPos, this.heightOffset);
            ctx.lineTo(peakPos, this.height - this.heightOffset);
            ctx.closePath();
            ctx.stroke();
        }

        this.lastPeakPos = peakPos;
    }

    _calculateLength(val) {
        let range = -48;
        let result = Math.floor(this.width - ((this.width * val) / range));
        return (result > 0) ? result : 0;
    }

    _checkResize() {
        let boundingBox = this.canvas.getBoundingClientRect();
        if ((boundingBox.width === this.width) && (boundingBox.height === this.height)) return;
        this.width = this.canvas.width = boundingBox.width;
        this.height = this.canvas.height = boundingBox.height;

        this.ctx = this.canvas.getContext('2d');

        if (this.graticules) {
            let ctx = this.ctx;
            ctx.fillStyle = '#fff';
            ctx.fillText('-42', this._calculateLength(-42), 10);
            ctx.fillText('-36', this._calculateLength(-36), 10);
            ctx.fillText('-30', this._calculateLength(-30), 10);
            ctx.fillText('-24', this._calculateLength(-24), 10);
            ctx.fillText('-18', this._calculateLength(-18), 10);
            ctx.fillText('-12', this._calculateLength(-12), 10);
            ctx.fillText('-6', this._calculateLength(-6), 10);
        }

        this.gradient = this.ctx.createLinearGradient(0, 0, this.width, 0);
        this.gradient.addColorStop(0.9, "red");
        this.gradient.addColorStop(0.7, "yellow");
        this.gradient.addColorStop(0.6, "lightgreen");
        this.ctx.strokeStyle = this.gradient;
    }
}